
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const MobileAlertIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M52 62C52 64.2091 50.2091 66 48 66C45.7909 66 44 64.2091 44 62C44 59.7909 45.7909 58 48 58C50.2091 58 52 59.7909 52 62Z" fill="#161617"/>
<path d="M44.5 31.5V50.5C44.5 52.433 46.067 54 48 54C49.933 54 51.5 52.433 51.5 50.5V31.5C51.5 29.567 49.933 28 48 28C46.067 28 44.5 29.567 44.5 31.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M30.5 8C24.701 8 20 12.701 20 18.5V77.5C20 83.299 24.701 88 30.5 88H65.5C71.299 88 76 83.299 76 77.5V18.5C76 12.701 71.299 8 65.5 8H30.5ZM27 18.5C27 16.567 28.567 15 30.5 15H34C34 16.933 35.567 18.5 37.5 18.5H58.5C60.433 18.5 62 16.933 62 15H65.5C67.433 15 69 16.567 69 18.5V77.5C69 79.433 67.433 81 65.5 81H30.5C28.567 81 27 79.433 27 77.5V18.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 18.5C23.5 14.634 26.634 11.5 30.5 11.5L65.5 11.5C69.366 11.5 72.5 14.634 72.5 18.5V77.5C72.5 81.366 69.366 84.5 65.5 84.5H30.5C26.634 84.5 23.5 81.366 23.5 77.5V18.5Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M52 62C52 64.2091 50.2091 66 48 66C45.7909 66 44 64.2091 44 62C44 59.7909 45.7909 58 48 58C50.2091 58 52 59.7909 52 62Z" fill="#161617"/>
<path d="M44.5 31.5V50.5C44.5 52.433 46.067 54 48 54C49.933 54 51.5 52.433 51.5 50.5V31.5C51.5 29.567 49.933 28 48 28C46.067 28 44.5 29.567 44.5 31.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M30.5 8C24.701 8 20 12.701 20 18.5V77.5C20 83.299 24.701 88 30.5 88H65.5C71.299 88 76 83.299 76 77.5V18.5C76 12.701 71.299 8 65.5 8H30.5ZM27 18.5C27 16.567 28.567 15 30.5 15H34C34 16.933 35.567 18.5 37.5 18.5H58.5C60.433 18.5 62 16.933 62 15H65.5C67.433 15 69 16.567 69 18.5V77.5C69 79.433 67.433 81 65.5 81H30.5C28.567 81 27 79.433 27 77.5V18.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 18.5C23.5 14.634 26.634 11.5 30.5 11.5L65.5 11.5C69.366 11.5 72.5 14.634 72.5 18.5V77.5C72.5 81.366 69.366 84.5 65.5 84.5H30.5C26.634 84.5 23.5 81.366 23.5 77.5V18.5Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
